import React from "react";
import {
  UserIcon,
  PhoneIcon,
  EnvelopeIcon,
  CurrencyDollarIcon,
  StarIcon,
} from "@heroicons/react/24/outline";

const UserCard = ({ user, isActive, onClick }) => (
  <div
    className={`rounded-xl cursor-pointer transition-all duration-300 transform hover:scale-[1.02] ${
      isActive
        ? "p-[2px] bg-accent-grad shadow-xl"
        : "border border-gray-700 hover:border-gray-600"
    }`}
    onClick={onClick}
  >
    <div
      className={`p-5 rounded-[10px] relative overflow-hidden ${
        isActive
          ? "user-card-inner-bg text-white"
          : "bg-gray-800/50 text-gray-300 hover:bg-gray-800"
      }`}
    >
      {isActive && (
        <div className="absolute inset-0 bg-accent-grad opacity-[0.05] pointer-events-none" />
      )}
      <div className="flex items-start space-x-4">
        <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 bg-accent-grad">
          <UserIcon className="w-6 h-6 text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-2 min-w-0">
              <h4
                className={`font-semibold text-lg truncate ${
                  isActive ? "bg-accent-grad bg-clip-text text-transparent" : ""
                }`}
              >
                {user.name || "Аты жоқ"}
              </h4>
              <span
                className={`text-[13px] capitalize flex-shrink-0 ${
                  isActive
                    ? "bg-accent-grad bg-clip-text text-transparent"
                    : "text-gray-400"
                }`}
              >
                • {user.user_type || "individual"}
              </span>
            </div>
            {user.is_active !== undefined && (
              <span
                className={`px-2 py-1 text-xs font-medium border flex-shrink-0 ml-2 flex items-center gap-1.5 ${
                  user.is_active
                    ? "badge-green"
                    : "bg-gray-500/20 text-gray-400 border-gray-500/50 rounded-[5px]"
                }`}
              >
                {user.is_active && (
                  <span className="w-[7px] h-[7px] rounded-full bg-green-grad flex-shrink-0" />
                )}
                {user.is_active ? (
                  <span className="bg-green-grad bg-clip-text text-transparent">
                    Белсенді
                  </span>
                ) : (
                  "Белсенді емес"
                )}
              </span>
            )}
          </div>
          <div className="space-y-1.5 text-sm">
            {user.phone_number && (
              <div className="flex items-center space-x-2">
                <PhoneIcon className="w-4 h-4 text-gray-500" />
                <span className="truncate">{user.phone_number}</span>
              </div>
            )}
            {user.email && (
              <div className="flex items-center space-x-2">
                <EnvelopeIcon className="w-4 h-4 text-gray-500" />
                <span className="truncate">{user.email}</span>
              </div>
            )}
            <div className="flex items-center space-x-4 pt-2">
              <div className="flex items-center space-x-1">
                <CurrencyDollarIcon className="w-4 h-4 text-yellow-400" />
                <span className="font-medium">{user.balance || 0} ₸</span>
              </div>
              <div className="flex items-center space-x-1">
                <StarIcon className="w-4 h-4 text-yellow-400" />
                <span>{user.rating || 0}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default UserCard;
